import { render, staticRenderFns } from "./BaseButtons.vue?vue&type=template&id=4a44db4c&scoped=true"
import script from "./BaseButtons.vue?vue&type=script&lang=ts"
export * from "./BaseButtons.vue?vue&type=script&lang=ts"
import style0 from "./BaseButtons.vue?vue&type=style&index=0&id=4a44db4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44db4c",
  null
  
)

export default component.exports